export default class API {
  constructor({ url }) {
    this.url = url
    this.endpoints = {}
  }

  createEntity(entity) {
    this.endpoints[entity.name] = {
      ...(entity.endpoints || {}),
    }
  }
}
